/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Create_Account_TitleInputs */

const en_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Account`)
};

const fr_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un Compte`)
};

const de_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerkonto erstellen`)
};

const it_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creare un account`)
};

const ru_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрироваться`)
};

const es_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una cuenta`)
};

const zh_cn2_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建账户`)
};

const ja_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを作成する`)
};

const hi_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता बनाएं`)
};

const pt_pt2_login_create_account_title = /** @type {(inputs: Login_Create_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar uma conta`)
};

/**
* | output |
* | --- |
* | "Create Account" |
*
* @param {Login_Create_Account_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_create_account_title = /** @type {((inputs?: Login_Create_Account_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Create_Account_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_create_account_title(inputs)
	if (locale === "de") return de_login_create_account_title(inputs)
	if (locale === "it") return it_login_create_account_title(inputs)
	if (locale === "ru") return ru_login_create_account_title(inputs)
	if (locale === "es") return es_login_create_account_title(inputs)
	if (locale === "zh-CN") return zh_cn2_login_create_account_title(inputs)
	if (locale === "ja") return ja_login_create_account_title(inputs)
	if (locale === "hi") return hi_login_create_account_title(inputs)
	if (locale === "pt-PT") return pt_pt2_login_create_account_title(inputs)
	return en_login_create_account_title(inputs)
});